import { render, staticRenderFns } from "./PauseComBox.vue?vue&type=template&id=361e6d45&"
import script from "./PauseComBox.vue?vue&type=script&lang=ts&"
export * from "./PauseComBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports